import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "quill/dist/quill.snow.css";

import {
  FaShoppingCart,
  FaFacebookSquare,
  FaInstagramSquare,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import { FiDownloadCloud } from "react-icons/fi";

function Crud({ baseURL }) {
  const [collection, setCollection] = useState("posts");
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({});
  const [questions, setQuestion] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const modalRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Registrar el módulo

  const [content, setContent] = useState("");
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // 🎨 botones de color de texto y fondo
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "align",
    "color",
    "background", // 🎨 importantes para los estilos
    "list",
    "bullet",
    "link",
    "image",
  ];
  const apiURL = `${baseURL}/${collection}`;

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault(); // Necesario en algunos navegadores
      e.returnValue = ""; // Esto activa el diálogo de confirmación
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Cargar items según colección activa
  useEffect(() => {
    fetch(apiURL)
      .then((res) => res.json())
      .then((data) => {
        setItems(data);
      })
      .catch(console.error);
  }, [collection]);

  // Cargar categorías solo una vez
  useEffect(() => {
    fetch(`${baseURL}/categories`)
      .then((res) => res.json())
      .then(setCategories)
      .catch(console.error);
  }, []);

  const changeCollection = (name) => {
    setCollection(name);
  };

  const openModal = (item = {}) => {
    setFormData(item);
    setContent(item.content);
    setEditingId(item._id || null);
    if (modalRef.current) modalRef.current.style.display = "block";
  };

  const closeModal = () => {
    setFormData({});
    setContent("");
    setEditingId(null);
    if (modalRef.current) modalRef.current.style.display = "none";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = document.getElementById("modalForm");
    const urlInputs = form.querySelectorAll("input[name^='urls.']");

    const urls = {};

    urlInputs.forEach((input) => {
      const [, server] = input.name.split(".");
      if (!urls[server]) urls[server] = [];
      if (input.value.trim()) {
        urls[server].push(input.value.trim());
      }
    });

    const dataToSend = {
      ...formData,
      content,
    };

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `${apiURL}/${editingId}` : apiURL;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend),
    });

    const data = await res.json();
    if (!res.ok) return alert(data.error || "Error");

    switch (collection) {
      case "posts":
        fetch(apiURL)
          .then((r) => r.json())
          .then(setItems);
        break;
      case "categories":
        fetch(apiURL)
          .then((r) => r.json())
          .then(setItems);
        fetch(apiURL)
          .then((r) => r.json())
          .then(setCategories);
        break;
      case "sections":
        fetch(apiURL)
          .then((r) => r.json())
          .then(setItems);
        break;

      default:
        fetch(apiURL)
          .then((r) => r.json())
          .then(setItems);
        break;
    }

    closeModal();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar este elemento?")) return;
    await fetch(`${apiURL}/${id}`, { method: "DELETE" });
    fetch(apiURL)
      .then((r) => r.json())
      .then(setCategories);
    fetch(apiURL)
      .then((r) => r.json())
      .then(setItems);
  };

  const handleDuplicate = async (item) => {
    const { _id, createdAt, updatedAt, ...rest } = item;
    const res = await fetch(apiURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(rest),
    });
    const data = await res.json();
    if (!res.ok) return alert(data.error || "Error");
    fetch(apiURL)
      .then((r) => r.json())
      .then(setItems);
    alert("Duplicado");
  };

  function handleUrlVideo(url) {
    let videoId;

    if (url.includes("youtube.com/watch?v=")) {
      videoId = `${url.split("?v=")[1]}`;
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes("youtu.be/")) {
      videoId = `${url.split(".be/")[1].split("?")[0]}`;
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes("youtube.com/embed/")) {
      return url;
    }

    return ``;
  }

  return (
    <div div className="crud-view">
      <div className="container">
        <h1>Panel de Administración</h1>

        {isLoggedIn ? (
          <div>
            <div className="tabs">
              <button
                className={`tab-button ${
                  collection === "posts" ? "active" : ""
                }`}
                onClick={() => changeCollection("posts")}
              >
                Programas
              </button>
              <button
                className={`tab-button ${
                  collection === "categories" ? "active" : ""
                }`}
                onClick={() => changeCollection("categories")}
              >
                Categorías
              </button>
              <button
                className={`tab-button ${
                  collection === "licenses" ? "active" : ""
                }`}
                onClick={() => changeCollection("licenses")}
              >
                Licencias
              </button>
              <button
                className={`tab-button ${
                  collection === "sections" ? "active" : ""
                }`}
                onClick={() => changeCollection("sections")}
              >
                Web
              </button>
            </div>

            <div className="collection-header">
              <h2>
                {collection.charAt(0).toUpperCase() + collection.slice(1)}
              </h2>
              {collection !== "web" && (
                <button className="btn" onClick={() => openModal()}>
                  Crear Nuevo
                </button>
              )}
              {collection === "web" && (
                <button className="btn" onClick={() => openModal()}>
                  Inspeccionar
                </button>
              )}
            </div>

            {items.length === 0 && <p>No hay elementos en esta sección.</p>}

            {/* TABLA POSTS */}
            {collection === "posts" && (
              <table className="crud-table">
                <thead>
                  <th>Titulo</th>
                  <th>Portada</th>
                  <th>Categoría</th>
                  <th>Fecha</th>
                  <th>Opciones</th>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>
                        <img
                          src={item.image}
                          alt={item.title}
                          style={{ width: "50px", height: "50px" }}
                          draggable={false}
                        />
                      </td>
                      <td>{item.category}</td>
                      <td>
                        {item.createdAt ? item.createdAt.split("T")[0] : null}
                      </td>
                      <td>
                        <button onClick={() => openModal(item)}>✏️</button>
                        <button onClick={() => handleDuplicate(item)}>
                          📰
                        </button>
                        <button onClick={() => handleDelete(item._id)}>
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* TABLA CATEGORÍAS */}
            {collection === "categories" && (
              <table className="crud-table">
                <thead>
                  <th>Categoría</th>
                  <th>Opciones</th>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>
                        <button onClick={() => openModal(item)}>✏️</button>
                        <button onClick={() => handleDelete(item._id)}>
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {collection === "sections" && (
              <>
                <table className="crud-table">
                  <thead>
                    <th>Sección</th>
                    <th>Opciones</th>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td>{item.name}</td>
                        <td>
                          <button onClick={() => openModal(item)}>✏️</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            {collection === "licenses" && (
              <table className="crud-table">
                <thead>
                  <th>Titulo</th>
                  <th>Descripción</th>
                  <th>Opciones</th>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>
                        <button onClick={() => openModal(item)}>✏️</button>
                        <button onClick={() => handleDelete(item._id)}>
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ) : (
          <div className="login-panel">
            <h2>Iniciar Sesión</h2>
            <form>
              <label>
                Usuario:
                <input type="text" name="username" autoComplete="username" required />
              </label>
              <label>
                Contraseña:
                <input type="password" name="password" autoComplete="current-password" required />
              </label>
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    e.target.form.username.value === "admin" &&
                    e.target.form.password.value === "sfgh12345"
                  ) {
                    setIsLoggedIn(true);
                    alert("Bienvenido administrador");
                  }
                  else { alert("Credenciales incorrectas"); }
                }}
              >
                Iniciar Sesión
              </button>
            </form>
          </div>
        )}
      </div>

      {/* MODAL */}
      <div className="modal" ref={modalRef} style={{ display: "none" }}>
        <div className="modal-content">
          <span className="close-btn" onClick={closeModal}>
            &times;
          </span>

          <h2>
            {editingId ? "Editar" : "Crear"} {collection}
          </h2>

          {/* Formularios para nuevos registros */}

          {collection === "posts" && (
            <div className="posts-tool">
              <form id="modalForm" onSubmit={handleSubmit}>
                <label>
                  Título:
                  <input
                    type="text"
                    placeholder="Titulo del programa"
                    maxLength={60}
                    value={formData.name || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    required
                  />
                </label>
                <label>
                  Portada:
                  <input
                    type="text"
                    maxLength={300}
                    placeholder="https//..."
                    value={formData.image || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, image: e.target.value })
                    }
                    required
                  />
                </label>
                <label>
                  Descripción:
                  <input
                    type="text"
                    maxLength={150}
                    placeholder="Descripción breve del programa..."
                    value={formData.description || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    required
                  />
                </label>
                <label>Contenido del Post:</label>
                <div className="text-editor">
                  <ReactQuill
                    value={content}
                    onChange={setContent}
                    modules={modules}
                    formats={formats}
                  />
                </div>
                <label>
                  Categoría:
                  <select
                    value={formData.category || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, category: e.target.value })
                    }
                    required
                  >
                    <option value="">Selecciona</option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat.name}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Links:
                  <input
                    type="url"
                    placeholder="https//..."
                    maxLength={300}
                    value={formData.links || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, links: e.target.value })
                    }
                  />
                  <hr />
                </label>

                <label>
                  Video Tutorial (Opcional):
                  <input
                    type="text"
                    maxLength={300}
                    value={formData.videoUrl || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        videoUrl: handleUrlVideo(e.target.value),
                      })
                    }
                    placeholder="https://www.youtube.com/watch?v=example"
                  />
                </label>
                <br />
                <button type="submit">Guardar</button>
              </form>
              <div className="post-preview">
                <div className="program-detail scaled">
                  <h2>{formData.name}</h2>
                  {formData.image && (
                    <img
                      src={formData.image}
                      alt="programImg"
                      draggable={false}
                    />
                  )}

                  <div
                    className="rendered-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                  ></div>

                  {formData.videoUrl && (
                    <>
                      <h3>Video Tutorial</h3>
                      <iframe src={formData.videoUrl} frameborder="0"></iframe>
                    </>
                  )}
                  {formData.links && (
                    <button onClick={() => window.open(formData.links)}>
                      <FiDownloadCloud />
                      Descargar
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {collection === "categories" && (
            <form id="modalForm" onSubmit={handleSubmit}>
              <label>
                Nombre:
                <input
                  type="text"
                  maxLength={20}
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </label>
              <button type="submit" className="btn">
                Guardar
              </button>
            </form>
          )}

          {collection === "sections" && (
            <div className="posts-tool">
              <form id="modalForm" onSubmit={handleSubmit}>
                <label>
                  Sección:
                  <input
                    type="text"
                    value={formData.name || ""}
                    disabled
                    required
                  />
                </label>

                {/* Formularios por sección */}

                {formData.name === "Inicio" && (
                  <>
                    <label>Header</label>
                    <hr />
                    <label>
                      Imagen:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.header.image || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            header: {
                              ...formData.header,
                              image: e.target.value,
                            },
                          })
                        }
                      />
                    </label>
                    <label>
                      Titulo:
                      <input
                        type="text"
                        maxLength={20}
                        value={formData.header.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            header: {
                              ...formData.header,
                              title: e.target.value,
                            },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Texto:
                      <input
                        type="text"
                        maxLength={60}
                        value={formData.header.text || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            header: {
                              ...formData.header,
                              text: e.target.value,
                            },
                          })
                        }
                        required
                      />
                    </label>
                    <hr />
                    <label>
                      Mensaje de bienvenida:
                      <input
                        type="text"
                        maxLength={40}
                        value={formData.a.welcMessage || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            a: { ...formData.a, welcMessage: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                  </>
                )}

                {formData.name === "Acerca de" && (
                  <>
                    <label>
                      Titulo:
                      <input
                        maxLength={20}
                        type="text"
                        value={formData.c.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, title: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Imagen 1:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.c.img1 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, img1: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <div className="text-editor">
                      <ReactQuill
                        value={formData.c.desc1 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, desc1: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>

                    <label>
                      Imagen 2:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.c.img2 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, img2: e.target.value },
                          })
                        }
                      />
                    </label>
                    <div className="text-editor">
                      <ReactQuill
                        value={formData.c.desc2 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, desc2: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>

                    <label>
                      Imagen 3:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.c.img3 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, img3: e.target.value },
                          })
                        }
                      />
                    </label>
                    <div className="text-editor">
                      <ReactQuill
                        value={formData.c.desc3 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            c: { ...formData.c, desc3: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </>
                )}

                {formData.name === "Contactenos" && (
                  <>
                    <label>
                      Titulo:
                      <input
                        maxLength={20}
                        type="text"
                        value={formData.d.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, title: e.target.value },
                          })
                        }
                        required
                      />
                    </label>

                    <div className="text-editor">
                      <ReactQuill
                        value={formData.d.desc1 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, desc1: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                    <label>
                      e-mail:
                      <input
                        type="text"
                        maxLength={50}
                        value={formData.d.email || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, email: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Numero:
                      <input
                        type="text"
                        placeholder="Sin espacios y con código, (+523841177360)"
                        maxLength={18}
                        value={formData.d.number || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, number: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Facebook:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.d.fb || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, fb: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Instagram:
                      <input
                        type="text"
                        maxLength={50}
                        value={formData.d.inst || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, inst: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      TikTok:
                      <input
                        type="text"
                        maxLength={50}
                        value={formData.d.Tkt || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            d: { ...formData.d, Tkt: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                  </>
                )}

                {formData.name === "Ayuda" && (
                  <>
                    <label>
                      Titulo:
                      <input
                        maxLength={20}
                        type="text"
                        value={formData.e.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            e: { ...formData.e, title: e.target.value },
                          })
                        }
                        required
                      />
                    </label>

                    <label>Preguntas:</label>
                    {formData.e.questions.map((fItem, index) => (
                      <div key={index}>
                        <input
                          type="text"
                          maxLength={50}
                          value={fItem.q}
                          onChange={(e) => {
                            const updatedQuestions = [...formData.e.questions];
                            updatedQuestions[index] = {
                              ...updatedQuestions[index],
                              q: e.target.value,
                            };
                            setFormData({
                              ...formData,
                              e: { ...formData.e, questions: updatedQuestions },
                            });
                          }}
                          placeholder="Pregunta"
                          required
                        />

                        <input
                          type="text"
                          maxLength={250}
                          value={fItem.a}
                          onChange={(e) => {
                            const updatedQuestions = [...formData.e.questions];
                            updatedQuestions[index] = {
                              ...updatedQuestions[index],
                              a: e.target.value,
                            };
                            setFormData({
                              ...formData,
                              e: { ...formData.e, questions: updatedQuestions },
                            });
                          }}
                          placeholder="Respuesta"
                          required
                        />

                        <button
                          type="button"
                          onClick={() => {
                            setFormData((prev) => ({
                              ...prev,
                              e: {
                                ...prev.e,
                                questions: prev.e.questions.filter(
                                  (_, i) => i !== index
                                ),
                              },
                            }));
                          }}
                        >
                          🗑️
                        </button>
                        <hr />
                      </div>
                    ))}

                    <div>
                      <button
                        type="button"
                        onClick={() => {
                          setFormData((prev) => ({
                            ...prev,
                            e: {
                              ...prev.e,
                              questions: [
                                ...(prev.e.questions || []),
                                { q: "", a: "" },
                              ],
                            },
                          }));
                        }}
                      >
                        Nueva +
                      </button>
                    </div>
                  </>
                )}

                {formData.name === "Tutoriales" && (
                  <>
                    <label>
                      Titulo:
                      <input
                        maxLength={20}
                        type="text"
                        value={formData.f.title || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            f: { ...formData.f, title: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                    <div className="text-editor">
                      <ReactQuill
                        value={formData.f.desc1 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            f: { ...formData.f, desc1: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                    <label>
                      Video 1:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.f.video1 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            f: {
                              ...formData.f,
                              video1: handleUrlVideo(e.target.value),
                            },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      Video 2:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.f.video2 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            f: {
                              ...formData.f,
                              video2: handleUrlVideo(e.target.value),
                            },
                          })
                        }
                        required
                      />
                    </label>
                    <label>
                      URL Canal YT:
                      <input
                        type="text"
                        maxLength={150}
                        value={formData.f.UrlYoutube || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            f: { ...formData.f, UrlYoutube: e.target.value },
                          })
                        }
                        required
                      />
                    </label>
                  </>
                )}

                {formData.name === "Mas" && (
                  <>
                    <div className="text-editor">
                      <ReactQuill
                        value={formData.g.desc1 || ""}
                        onChange={(val) =>
                          setFormData({
                            ...formData,
                            g: { ...formData.g, desc1: val },
                          })
                        }
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </>
                )}

                <br />
                <button type="submit">Guardar</button>
              </form>

              {/* Previews por sección */}

              {formData.name === "Inicio" && (
                <>
                  <div
                    className="scaled2"
                    id="hero"
                    style={{ minWidth: "80%" }}
                  >
                    {formData.header.image && (
                      <div className="hero0">
                        <img
                          src={
                            formData.header.image ||
                            "https://placehold.co/500x350/3473ad/fff?text=Logo"
                          }
                          alt="heroImg"
                          draggable={false}
                        />
                      </div>
                    )}

                    <div className="hero1">
                      <h1>{formData.header.title}</h1>
                      <p>{formData.header.text}</p>
                      <button>Comenzar</button>
                    </div>
                  </div>
                </>
              )}

              {formData.name === "Acerca de" && (
                <>
                  <div
                    className="g-section scaled2"
                    id="section-about"
                    style={{ minWidth: "100%", scale: ".8" }}
                  >
                    <h2>{formData.c.title}</h2>
                    {formData.c.img1 ? (
                      <img src={formData.c.img1} alt="Equipo de trabajo" />
                    ) : null}

                    <div
                      className="rendered-content"
                      dangerouslySetInnerHTML={{ __html: formData.c.desc1 }}
                    ></div>
                    {formData.c.img2 ? (
                      <img src={formData.c.img2} alt="Equipo de trabajo" />
                    ) : null}

                    <div
                      className="rendered-content"
                      dangerouslySetInnerHTML={{ __html: formData.c.desc2 }}
                    ></div>
                    {formData.c.img3 ? (
                      <img src={formData.c.img3} alt="Equipo de trabajo" />
                    ) : null}

                    <div
                      className="rendered-content"
                      dangerouslySetInnerHTML={{ __html: formData.c.desc3 }}
                    ></div>
                  </div>
                </>
              )}

              {formData.name === "Contactenos" && (
                <>
                  <div
                    className="g-section scaled2"
                    id="section-contact"
                    style={{ minWidth: "100%", scale: ".8" }}
                  >
                    <h2>{formData.d.title}</h2>
                    <div
                      className="rendered-content"
                      dangerouslySetInnerHTML={{ __html: formData.d.desc1 }}
                    ></div>
                    {formData.d.number ? (
                      <form>
                        <input type="text" placeholder="Tu nombre" required />
                        <input
                          type="email"
                          placeholder="Tu correo electrónico"
                          required
                        />
                        <textarea
                          placeholder="Tu mensaje"
                          rows="4"
                          required
                        ></textarea>
                        <button type="submit">Enviar</button>
                      </form>
                    ) : null}
                    {formData.d.email ? (
                      <a href="mailto:">email@example.com</a>
                    ) : null}
                    <div className="social-icons">
                      {formData.d.fb ? (
                        <a
                          href={formData.d.fb}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebookSquare />
                        </a>
                      ) : null}
                      {formData.d.inst ? (
                        <a
                          href={formData.d.inst}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaInstagramSquare />
                        </a>
                      ) : null}
                      {formData.d.Tkt ? (
                        <a
                          href={formData.d.Tkt}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaTiktok />
                        </a>
                      ) : null}
                    </div>
                  </div>
                </>
              )}

              {formData.name === "Ayuda" && (
                <>
                  <div
                    className="g-section scaled2"
                    id="section-help"
                    style={{ minWidth: "100%", scale: ".8" }}
                  >
                    <h2>{formData.e.title}</h2>
                    <p>
                      Visita nuestra sección de preguntas frecuentes y encuentra
                      soluciones rápidas a los problemas más comunes.
                    </p>

                    {formData.e.questions.map((q, index) => (
                      <details>
                        <summary>{q.q}</summary>
                        <p>{q.a}</p>
                      </details>
                    ))}
                  </div>
                </>
              )}

              {formData.name === "Tutoriales" && (
                <div
                  className="g-section scaled2"
                  id="section-tutorials"
                  style={{ minWidth: "100%", scale: ".8" }}
                >
                  <h2>{formData.f.title}</h2>
                  <div
                    className="rendered-content"
                    dangerouslySetInnerHTML={{ __html: formData.f.desc1 }}
                  ></div>

                  <div class="videos-grid">
                    <iframe
                      width="800"
                      height="400"
                      src={formData.f.video1}
                      title="Tutorial 1"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                    {formData.f.video2 ? (
                      <iframe
                        width="800"
                        height="400"
                        src={formData.f.video2}
                        title="Tutorial 3"
                        frameborder="0"
                        allowfullscreen
                      ></iframe>
                    ) : null}
                  </div>
                  {formData.f.UrlYoutube ? (
                    <button
                      class="canal-btn"
                      onClick={() => window.open(formData.f.UrlYoutube)}
                    >
                      <FaYoutube /> YouTube
                    </button>
                  ) : null}
                </div>
              )}

              {formData.name === "Mas" && (
                <div
                  className="g-section scaled2"
                  style={{ minWidth: "100%", scale: ".8" }}
                >
                  <div
                    className="rendered-content"
                    dangerouslySetInnerHTML={{ __html: formData.g.desc1 }}
                  ></div>
                </div>
              )}
            </div>
          )}

          {collection === "licenses" && (
            <form id="modalForm" onSubmit={handleSubmit}>
              <label>
                Titulo:
                <input
                  type="text"
                  maxLength={60}
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </label>
              <label>
                Descripción:
                <input
                  type="text"
                  maxLength={60}
                  value={formData.description || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  required
                />
              </label>
              <label>Características:</label>
              {formData.features?.map((fItem, index) => (
                <div key={index}>
                  <input
                    type="text"
                    value={fItem}
                    maxLength={38}
                    onChange={(e) => {
                      const updatedFeatures = [...formData.features];
                      updatedFeatures[index] = e.target.value;
                      setFormData({
                        ...formData,
                        features: updatedFeatures,
                      });
                    }}
                    required
                  />

                  <button
                    type="button"
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        features: prev.features.filter((_, i) => i !== index),
                      }));
                    }}
                  >
                    🗑️
                  </button>
                  <hr />
                </div>
              ))}

              <div>
                <button
                  type="button"
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      features: [...(prev.features || []), ""],
                    }));
                  }}
                >
                  Nueva +
                </button>
              </div>

              <label>
                Link de acceso:
                <input
                  type="url"
                  maxLength={70}
                  value={formData.link || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, link: e.target.value })
                  }
                  required
                />
              </label>
              <button type="submit" className="btn">
                Guardar
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Crud;
